/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { Utils } from '../../utils/api';
import { AiOutlineWarning } from 'react-icons/ai';
import { Tooltip, PlayersTable, DynamicRow, TableColumnWrapper, AlertTextWrapper, AlertIconWrapper, PopUpText } from './styles';
import { NavbarButton, PowerInput, PowerDropdown, InputCheckbox, ChangeSelected, Badge, Media } from '..';
import {
  defaultSponsor,
  TYPES_INVITATIONS,
  INVALID_TO_SPONSOR,
  WARNING_TO_SPONSOR,
  INVITE_SELECTED_DEFAULT,
  SPONSOR_SELECTED_DEFAULT,
} from '../../utils/constants/defaultSponsor';
import { MessagesConstants } from '../../utils/constants/messages';
import { AdBodyTitle } from '../../pages/admin/styles';



export default ({
  dataTableContent,
  teamMemo,
  updateTableContent,
  errorData,
  membershipsYearly,
  membershipsYearlyCount,
  membershipsYearlyTotal,
  changeMembershipsYearly,
  changeErrorBulkInit,
}: {
  dataTableContent: Array<any>;
  teamMemo: Array<any>;
  updateTableContent: any;
  errorData: Array<string>;
  membershipsYearly: Array<any>;
  membershipsYearlyCount: number;
  membershipsYearlyTotal: number;
  changeMembershipsYearly: any;
  changeErrorBulkInit: any;
}) => {
  const [warning, useWarning] = useState({ name: [], mail: [], last: [], correo: [], sponsor: [] });
  const [selected, useSelected] = useState(Array<any>);
  const [sponsor, useSponsor] = useState<any>(INVITE_SELECTED_DEFAULT);
  const [team, useTeam] = useState<any>([]);
  const [removed, useRemoved] = useState<boolean>(false);
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [firstRender, setFirstRender] = useState<boolean>(true);
  const [isReRenderTable, setIsReRenderTable] = useState<boolean>(true);

  const UTILS = new Utils();
  const inputPattern = UTILS.GetValidationInputPattern();
  const isBlankInput = UTILS.GetValidationBlankPattern();
  useEffect(() => {
    useSelected(dataTableContent);
  }, [])

  useEffect(() => {
    // This function is still running but the output is disabled, this can be erase if no use in the future.
    if(isReRenderTable){
      reviewData();
    }
  }, [isReRenderTable]);
  useEffect(() => {
    if(isAllSelected){
            dataTableContent.map((player, ind) => {
          const founded = selected.find(el => el.index === player.index); // Check if the player is already in the selected list by email
          if(!founded)
            useSelected(prev => [...prev, {...player, index: ind }]) // Add the player to the selected list
      })
    }else{
      useSelected([])
    }
  }, [isAllSelected])
  useEffect(()=>{
    if(selected.length === dataTableContent.length){
      setIsAllSelected(true)
    }
  },[selected, dataTableContent])

  async function reviewData(){
    const duplexData = await returnDuplex(dataTableContent);
    const badNameData = await returnBadName(dataTableContent, duplexData);
    const badLastData = await returnBadLast(dataTableContent, badNameData);
    const badEmailData = await returnBadEmail(dataTableContent, badLastData);
    const invitation = await returnInvalidSponsor(dataTableContent, badEmailData);
    changeErrorBulkInit(false)
    useWarning(invitation);
    setFirstRender(false);
    setIsReRenderTable(false)
  }
  function returnDuplex(content: Array<any>): Promise<any> {
    let memory: any = {};
    content.map(el => {
      try {
        memory[`${el[2]}`] = { mail: el[2], counter: memory[`${el[2]}`].counter + 1 };
      } catch {
        Object.defineProperty(memory, `${el[2]}`, {
          value: { mail: el[2], counter: 0 },
          writable: true,
          configurable: true,
          enumerable: true,
        });
      }
      return el;
    });
    const mailResolve = { mail: Object.values(memory).filter((el: any) => el.counter > 0) };
    /**duplicate users are searched for and the alert message is added */
    mailResolve.mail.forEach((email: any) => {
      dataTableContent.map(item => {
        if (item[2] === email.mail) {
          if (!item.message) {
            if (item[2] === undefined) item.message = 'There is no email';
            else item.message = MessagesConstants.BULK_UPLOAD.MESSAGE_EMAIL_DUPLICATE;
          }
        }
        return item;
      })
    });
    if(mailResolve.mail.length === 0){
      dataTableContent.map(item => {
        if (item.message === MessagesConstants.BULK_UPLOAD.MESSAGE_EMAIL_DUPLICATE) {
          item.message = null;
        }
      })
    }

    return new Promise(resolve => {
      resolve(mailResolve);
    });
  }

  function returnInvalidSponsor(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    content.map(el => {
      if (el.color === INVALID_TO_SPONSOR || el.color === WARNING_TO_SPONSOR) {
        try {
          memory[`${el[2]}`] = { sponsor: el[2], counter: memory[`${el[2]}`].counter + 1 };
        } catch {
          Object.defineProperty(memory, `${el[2]}`, {
            value: { sponsor: el[2], color: el.color, counter: 0 },
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });
    return new Promise(resolve => {
      resolve({ ...prev, sponsor: Object.values(memory) });
    });
  }

  function returnBadName(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    content.map(el => {
      if (!inputPattern.test(el[0]) || isBlankInput.test(el[0])) {
        try {
          el.messageName = MessagesConstants.BULK_UPLOAD.INVALID_FORMAT_NAME(el[0]);
          memory[`${el[0]}`] = { name: el[0], counter: memory[`${el[0]}`].counter + 1 };
        } catch {
          Object.defineProperty(memory, `${el[0]}`, {
            value: { name: el[0], counter: 0 },
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });
    return new Promise(resolve => {
      resolve({ ...prev, name: Object.values(memory) });
    });
  }

  function returnBadLast(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    content.map(el => {
      if (!inputPattern.test(el[1]) || isBlankInput.test(el[1])) {
        try {
          el.messageLastName = MessagesConstants.BULK_UPLOAD.INVALID_FORMAT_LAST_NAME(el[1]);
          memory[`${el[1]}`] = { last: el[1], counter: memory[`${el[1]}`].counter + 1 };
        } catch {
          Object.defineProperty(memory, `${el[1]}`, {
            value: { last: el[1], counter: 0 },
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });
    return new Promise(resolve => {
      resolve({ ...prev, last: Object.values(memory) });
    });
  }

  function returnBadEmail(content: Array<any>, prev: Array<any>): Promise<any> {
    let memory = {};
    const emailPattern = UTILS.GetValidationEmailPattern();

    content.map(el => {
      if (!emailPattern.test(el[2]?.trim())) {
        try {
          el.message = MessagesConstants.BULK_UPLOAD.EMAIL_WRONG_FORMAT;
          memory[`${el[2]}`] = { correo: el[2], counter: memory[`${el[2]}`].counter + 1 };
        } catch {
          Object.defineProperty(memory, `${el[2]}`, {
            value: { correo: el[2], counter: 0 },
            writable: true,
            configurable: true,
            enumerable: true,
          });
        }
      }
      return el;
    });

    return new Promise(resolve => {
      resolve({ ...prev, correo: Object.values(memory) });
    });
  }
  function addToSelected(selectedPlayer: any){
    // setIsAllSelected(false)
    const founded = selected.find(el => el.index === selectedPlayer.index); // Check if the player is already in the selected list by email
    if (founded) {
      useSelected(prev => {
        const modSelected = prev.filter(el => selectedPlayer[2] !== el[2]);
        return [...modSelected];
      }) // Remove the player from the selected list
    } else {
      useSelected(prev => [...prev, selectedPlayer]) // Add the player to the selected list
    }
  }

  function AddTeam(selectedTeam: any): void {
    useTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        return modTeams;
      } else {
        const modTeams = [...prev];
        return modTeams;
      }
    });
  }

  function handleCancelBadge(element) {
    useTeam([...team.filter(el => element._id !== el._id)]);
  }

  function ChangeSponsor(selectedOption: any) {
    useSponsor(selectedOption);
  }

  function selectAll() {
    setIsAllSelected(!isAllSelected);
  }

  function HandleDelete(email: string, indexTable: number) {
    useSelected(prev => [
      ...prev.filter(item => item[2] !== email)
    ])
    updateTableContent(prev => prev.filter((_, ind) => ind !== indexTable));
    setIsReRenderTable(true)
  }

  function HandleDeleteSelected() {
    useRemoved(!removed)
  }

  return (
    <>
      <ChangeSelected
        selected={selected}
        team={team}
        selectAll={() => selectAll()}
        ChangeTeam={AddTeam}
        handleCancelBadge={handleCancelBadge}
        teamMemo={teamMemo}
        ChangeSponsor={ChangeSponsor}
        sponsor={sponsor}
        handleDeleteSelected={HandleDeleteSelected}
        membershipsYearlyCount={membershipsYearlyCount}
        type={'player'}
      />
      <AdBodyTitle><PopUpText><b>{dataTableContent.length}</b> {" "} Total Players</PopUpText></AdBodyTitle>


      <PlayersTable>
        <thead>
          <tr>
            <th colSpan={3}>SPREADSHEET INFORMATION</th>
          </tr>
          <tr>
            <th>
              <div style={{ marginLeft: '3px' }}>
                <InputCheckbox icon={'line'} onClick={() => selectAll()} checked={selected.length === dataTableContent.length} />
                <span>FIRST NAME</span>
              </div>
            </th>
            <th>
              <div>
                <span>LAST NAME</span>
              </div>
            </th>
            <th>EMAIL</th>
            <th>TEAM</th>
            <th colSpan={2}>
              <div style={{ minWidth: '450px', justifyContent: 'space-between' }}>
                <div style={{ marginLeft: '5px' }}>
                  <span style={{ marginLeft: '10px' }}>SPONSORSHIP TYPE</span>
                </div>

                <div style={{ minWidth: '255px', display: 'inline-flex', justifyContent: 'flex-start', marginLeft: '10px' }}>
                  <div>LENGTH</div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataTableContent
            .filter(el => {
              const result = errorData.filter(il => il[2].toLowerCase() === el[2].toLowerCase());
              return !Boolean(result.length);
            })
            .map((item, index) => (
              <TableItem
                key={index}
                teamMemo={teamMemo}
                item={item}
                index={index}
                handleDelete={HandleDelete}
                updateTableContent={updateTableContent}
                warnings={warning}
                useWarning={useWarning}
                addToSelected={addToSelected}
                selected={selected}
                useSelected={useSelected}
                SelectedsTeam={team}
                SelectedSponsor={sponsor}
                membershipsYearly={membershipsYearly}
                membershipsYearlyCount={membershipsYearlyCount}
                membershipsYearlyTotal={membershipsYearlyTotal}
                changeMembershipsYearly={changeMembershipsYearly}
                removed={removed}
                firstRender={firstRender}
                setIsReRenderTable={setIsReRenderTable}
              />
            )
            )
          }
          {errorData.map((item, idx) => (
            <TableError key={idx} item={item} />
          ))}
        </tbody>
      </PlayersTable>
    </>
  );
};

const TableItem = ({
  teamMemo,
  item,
  index,
  handleDelete,
  updateTableContent,
  warnings,
  useWarning,
  addToSelected,
  selected,
  useSelected,
  SelectedsTeam,
  SelectedSponsor,
  membershipsYearly,
  membershipsYearlyCount,
  membershipsYearlyTotal,
  changeMembershipsYearly,
  removed,
  firstRender,
  setIsReRenderTable,
}) => {
  const [sponsor, useSponsor] = useState<any>(INVITE_SELECTED_DEFAULT);
  const [team, useTeam] = useState<any>([]);
  const [selectedBlock, setSelectedBlock] = useState<any>();
  const [membershipBlock, setMembershipBlock] = useState<any>();
  const [indexSelectedMembership, setIndexSelectedMembership] = useState<number>(-1);
  useEffect(() => {
    if (!firstRender) assignMemberships();
  }, [firstRender]);
  useEffect(() => {
    if(item.length > 3){
      const updatedSponsor = defaultSponsor.find(el => el.value === item[4].value);
      useSponsor(updatedSponsor);
      const updatedBlock = membershipsYearly.find(el => el.blockId === item[6]);
      setSelectedBlock(updatedBlock);
      if(updatedBlock)
        ChangeBlock(updatedBlock, membershipsYearly);
    }
    const teamForRow = teamMemo?.filter(el => item[3]?.includes(el._id));
    useTeam(teamForRow);
  }, [item])

  useEffect(() => {
    if (selected.some(element => element.index === index)) {
      const found = selected.find(element => element.index === index);
      liberateMembership();
      updateTableContent(prev => prev.filter(el => el[0] !== found[0] || el[1] !== found[1] || el[2] !== found[2]));
      useSelected(prev => [
        ...prev.filter(prev => prev.index !== index)
      ])
      setIsReRenderTable(true)
    }
  }, [removed])

  useEffect(() => {
    if (checked()) {
      ChangeTeam(SelectedsTeam)
    }
  }, [SelectedsTeam]);

  useEffect(() => {
    if (checked()) {
      ChangeSponsor(SelectedSponsor);
    }
  }, [SelectedSponsor]);

  useEffect(() => {
    if (checked()) {
      if (sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
        ChangeBlock({ name: 'new' });
      }
    }
  }, [sponsor]);

  function assignMemberships() {
    let availableMembership = membershipsYearly?.find((item: any) => item.unused && !item.selected);
    let availableUsedMembership = membershipsYearly?.find((item: any) => !item.unused && !item.selected);
    if (availableMembership && item.color !== INVALID_TO_SPONSOR) {
      ChangeSponsor(SelectedSponsor);
      ChangeTeam(SelectedsTeam);
    } else if (availableUsedMembership && item.color !== INVALID_TO_SPONSOR) {
      ChangeSponsor(SelectedSponsor);
      ChangeTeam(SelectedsTeam);
    } else {
      ChangeSponsor(INVITE_SELECTED_DEFAULT)
      ChangeTeam(SelectedsTeam, INVITE_SELECTED_DEFAULT);
      if (item.isSameOrg && (!item.message || item.message === MessagesConstants.BULK_UPLOAD.MESSAGE_EMAIL_DUPLICATE)) {
        updateTableContent(prev => [
          ...prev.map((el: any) => {
            if (el[2] === item[2]) {
              return { ...el, color: INVALID_TO_SPONSOR, message: 'This player already belongs to the organization' }
            } else return el;
          }),
        ]);

        useWarning(prev => {
          let found = prev['sponsor'].find((element: any) => element.sponsor === item[2]);
          if (!found) {
            return { ...prev, sponsor: [...prev.sponsor, { sponsor: item[2], color: INVALID_TO_SPONSOR, counter: 0 }] }
          } else {
            return prev
          }
        });

        updateTableContent(prev => {
          let invalidToSponsor = prev.filter((item: any) => item.color === INVALID_TO_SPONSOR);
          let warningToSponsor = prev.filter((item: any) => item.color === WARNING_TO_SPONSOR);
          let allData = [...invalidToSponsor, ...warningToSponsor, ...prev];
          let hash = {};
          return allData.filter(o => hash[o.id] ? false : hash[o.id] = true);
        });
      }
    }
  }

  function AddTeam(selectedTeam: any): void {
    if (checked()) {
      return;
    } else {
      useTeam(prev => {
        if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
          infoChange([...prev, selectedTeam], null);
          return [...prev, selectedTeam];

        } else {
          infoChange([...prev], null);
          return [...prev];
        }
      });
    }
  }

  function ChangeTeam(selectedOption: any, sponsor?: any) {
    useTeam(selectedOption);
    infoChange(selectedOption, sponsor || null);
  }

  async function ChangeSponsor(selectedOption: any) {
    if (item.color !== INVALID_TO_SPONSOR) {
      if (selectedOption.value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
        setMembershipBlock(membershipsYearly)
      } else {
        updateTableContent(prev => [
          ...prev.map((el) => {
            if (el[2] !== item[2]) {
              return el;
            } else {
              delete el[6];
              return el;
            }
          }),
        ]);
      }
      if (selectedOption !== sponsor && indexSelectedMembership > -1) {
        let updateArray = [...membershipBlock || membershipsYearly];
        updateArray[indexSelectedMembership].selected = false;
        changeMembershipsYearly(updateArray);
        setSelectedBlock(null);
        setIndexSelectedMembership(-1);
      }
      useSponsor(selectedOption);
      infoChange('', selectedOption);
    } else {
      useSponsor(INVITE_SELECTED_DEFAULT)
    }
  }

  function ChangeBlock(selectedOption: any, membershipArray: Array<any> = membershipBlock) {
    let updateArray = [...membershipArray];
    let option = selectedOption;
    if (option.name === 'new') {
      option = membershipArray.find(item => item.unused && !item.selected)
      if (!option) return;
    }
    let index = membershipArray.indexOf(option);
    if (indexSelectedMembership > -1) {
      updateArray[indexSelectedMembership].selected = false;
    }
    updateArray[index].selected = true;
    if (sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
      changeMembershipsYearly(updateArray);
    }
    updateTableContent(prev => [
      ...prev.map((el) => {
        if (el[2] !== item[2]) {
          return el;
        } else {
          el[6] = option.blockId;
          return el;
        }
      }),
    ]);
    setIndexSelectedMembership(index);
    setSelectedBlock(option);
  }

  function add(index: number) {
    addToSelected({ ...item, index });
  }

  function checked() {
    let element = selected.find((e: any, ind) => e.index === index);
    if (!element) return false;
    else return true;
  }

  function infoChange(iTeam: any = teamMemo[0], iSponsor: any = SPONSOR_SELECTED_DEFAULT) {
    if (iTeam) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          if (id !== index) {
            return el;
          } else {
            el[3] = iTeam.map(team => (team = team._id));
            return el;
          }
        }),
      ]);
    }
    if (iSponsor) {
      updateTableContent(prev => [
        ...prev.map((el, id) => {
          if (id !== index) {
            return el;
          } else {
            el[4] = iSponsor;
            return el;
          }
        }),
      ]);
    }
  }

  function handleCancelBadge(element) {
    if (checked()) {
      return;
    } else {
      const restOfTeam = team.filter(el => element._id !== el._id)
      useTeam([...restOfTeam]);
      infoChange([...restOfTeam], null);
    }
  }

  function liberateMembership() {
    if (indexSelectedMembership > -1 && membershipBlock) {
      let updateArray = [...membershipBlock];
      updateArray[indexSelectedMembership].selected = false;
      changeMembershipsYearly(updateArray);
    }
  }

  function parseDateYearlyMembership(date: string) {
    let nDate = new Date(date);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[nDate.getMonth()] + " " + nDate.getUTCDate() + "-" + String(nDate.getFullYear()).substring(2, 4);
  }

  return (
    <DynamicRow checked={checked()}>
      <td>
        {Boolean(warnings.name.filter(il => il.name === item[0])[0]) ? (
          <TableColumnWrapper>
            <InputCheckbox onClick={() => add(index)} checked={checked()} />
            <AlertTextWrapper>{item[0]}</AlertTextWrapper>
            <AlertIconWrapper>
              <AiOutlineWarning size="20px" />
              <Tooltip><span>{item['messageName']}</span></Tooltip>
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <InputCheckbox onClick={() => add(index)} checked={checked()} />
            <span>{item[0]}</span>
          </TableColumnWrapper>
        )}
      </td>
      <td>
        {Boolean(warnings.last.filter(il => il.last === item[1])[0]) ? (
          <TableColumnWrapper>
            <AlertTextWrapper>{item[1]}</AlertTextWrapper>
            <AlertIconWrapper>
              <AiOutlineWarning size="20px" />
              <Tooltip><span>{item['messageLastName']}</span></Tooltip>
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <span>{item[1]}</span>
          </TableColumnWrapper>
        )}
      </td>
      <td>
        {Boolean(warnings.correo.filter(il => il.correo === item[2])[0]) ||
          Boolean(warnings.mail.filter(il => il.mail === item[2])[0]) ||
          Boolean(warnings.sponsor.filter(il => il.sponsor === item[2])[0]) ? (
          <TableColumnWrapper>
            <AlertTextWrapper alertTextColor={item.color === INVALID_TO_SPONSOR ? '#f54b23' : '#FFD200'}>{item[2]}</AlertTextWrapper>
            <AlertIconWrapper alertTextColor={item.color === INVALID_TO_SPONSOR ? '#f54b23' : '#FFD200'}>
              <AiOutlineWarning size="20px" />
              <Tooltip><span>{item['message']}</span></Tooltip>
            </AlertIconWrapper>
          </TableColumnWrapper>
        ) : (
          <TableColumnWrapper>
            <span>{item[2]}</span>
          </TableColumnWrapper>
        )}
      </td>

      <td>
        <TableColumnWrapper>
          <div style={{ minWidth: '-webkit-fill-available' }}>
            <PowerInput
              search={true}
              onClick={AddTeam}
              dataArray={Boolean(team.length) ? teamMemo.filter(el => el.badge !== 'ALL') : teamMemo}
              selectedTeams={team}
              handleCancel={handleCancelBadge}
              maxWidth="800px"
            />
          </div>
        </TableColumnWrapper>
      </td>
      <td>
        <div style={{ display: 'inline-flex', justifyContent: 'center', padding: '2.5px 2.5px 2.5px 2.5px' }}>
          {item.color !== INVALID_TO_SPONSOR ? (
            <div style={{ maxWidth: '190px', display: 'inline-flex' }}>

              <PowerDropdown
                mHeigth="132px"
                mWidth="190px"
                onClick={ChangeSponsor}
                search={false}
                dataArray={defaultSponsor}
                primaryTitle={sponsor.name}
                mPadding="4px 0 4px 10px"
                theme={'gray'}
                membershipCount={{ yearly: membershipsYearlyTotal, selected: 0 }}
              />
            </div>
          ) : (
            <div style={{ minWidth: '190px' }} />
          )}
          {sponsor.type === TYPES_INVITATIONS.SPONSOR_PLAYER ? (
            <div style={{ maxWidth: '280px', display: 'inline-flex' }}>
              {(sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER) && (
                <PowerDropdown
                  search={false}
                  mHeigth="132px"
                  mWidth="280px"
                  firstActve={true}
                  onClick={ChangeBlock}
                  dataArray={membershipsYearly}
                  primaryTitle={selectedBlock ? (!selectedBlock.unused ?
                    `${selectedBlock?.remainingPeriod} Remaining | EXP: ${parseDateYearlyMembership(selectedBlock?.endDate)}` :
                    `Enrolled`) : 'Select option'}
                  mPadding="4px 0 4px 10px"
                  isEnrolled={!!selectedBlock?.unused}
                  membershipInfo={{ name: sponsor.value, count: membershipsYearlyCount }}
                />
              )}
            </div>
          ) : (
            <div style={{ minWidth: '280px', display: 'inline-flex' }}></div>
            )}
          <div style={{ maxWidth: '50px', display: 'inline-flex' }}>
            <NavbarButton title="X" icon="trash" onClick={() => { liberateMembership(); handleDelete(item[2], index) }} />
          </div>
        </div>
      </td>
    </DynamicRow>
  );
};

const TableError = ({ item }) => (
  <DynamicRow first={true}>
    <td>
      <TableColumnWrapper>
        <Media name={`${item[0]}`} fontSize="14px" />
      </TableColumnWrapper>
    </td>
    <td>
      <TableColumnWrapper>
        <span>{item[1]}</span>
      </TableColumnWrapper>
    </td>
    <td>
      <TableColumnWrapper>
        <AlertIconWrapper>
          <AiOutlineWarning size="20px" />
        </AlertIconWrapper>
        <AlertTextWrapper>{item[2]}</AlertTextWrapper>
      </TableColumnWrapper>
    </td>
    <td>
      <TableColumnWrapper>
        <Badge text={item[3]?.initials} color={item[3]?.color || '#007AFF'} />
        <span style={{ display: 'inline-flex', marginLeft: '5px', color: 'var(--ContrastGray', fontSize: '16px', fontWeight: 'normal' }}>
          {item[3]?.name || 'All Players'}
        </span>
      </TableColumnWrapper>
    </td>
    <td colSpan={2}>
      <TableColumnWrapper>
        <span style={{ color: '#5D6E81', fontWeight: 'normal' }}>
          <strong className="warning">INVITE NOT SENT: </strong> This player already belongs to the database
        </span>
      </TableColumnWrapper>
    </td>
  </DynamicRow>
);
